var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "15px",
    viewBox: "0 0 9 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 678") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inbox-show-details",
    transform: "translate(-445.000000, -717.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-678",
    transform: "translate(445.000000, 717.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1518",
    points: "0.000625 11.875 8.75 11.875 8.75 3.125 0.000625 3.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375,14.0625 C4.030625,14.0625 3.75,13.7825 3.75,13.4375 C3.75,13.0925 4.030625,12.8125 4.375,12.8125 C4.719375,12.8125 5,13.0925 5,13.4375 C5,13.7825 4.719375,14.0625 4.375,14.0625 L4.375,14.0625 Z M0.000625,12.5 L0.000625,13.4375 C-4.16084268e-15,14.299375 0.70125,15 1.5625,15 L7.1875,15 C8.04875,15 8.75,14.299375 8.75,13.4375 L8.75,12.5 L0.000625,12.5 Z",
    id: "Fill-1519"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125,1.25 L5.9375,1.25 C6.11,1.25 6.25,1.39 6.25,1.5625 C6.25,1.735 6.11,1.875 5.9375,1.875 L2.8125,1.875 C2.64,1.875 2.5,1.735 2.5,1.5625 C2.5,1.39 2.64,1.25 2.8125,1.25 L2.8125,1.25 Z M8.75,2.5 L8.75,1.5625 C8.75,0.700625 8.04875,0 7.1875,0 L1.5625,0 C0.70125,0 -4.33019506e-15,0.700625 0.000625,1.5625 L0.000625,2.5 L8.75,2.5 Z",
    id: "Fill-1520"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile_icon.f28a5631f6e855341c60ff4be37af227.svg";